import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/yaGPTLoading.svg';

export const IconYaGPTLoading = createIconComponent(Icon);
